// extracted by mini-css-extract-plugin
export default {"deleteServiceModalWrap":"DeleteRequestModal_deleteServiceModalWrap__aI-If"};